import React, { useState } from "react";
import { useFetchHistory, useFetchProcessedFile } from "store/backend/apiHooks";
import { PrimaryButton } from "widgets";
import { FILE_UPLOAD_STATUS } from "constants/constants";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import styles from "./History.module.scss";
import Loader from "shared/Loader/Loader";

const handleOnClickDownloadProcessedFile = (
  fileId,
  fetchProcessedFile,
  openSnackbar
) => {
  if (fileId) {
    fetchProcessedFile(fileId)
      .then((response) => {
        const link = document.createElement("a");
        link.href = response.signedUrl;
        link.click();
        openSnackbar("Processed File downloaded successfully!", "success");
      })
      .catch((error) => {
        console.error("Error fetching Processed File", error);
        openSnackbar(error.message || "Error fetching Processed File", "error");
      });
  } else {
    console.error("No File Id provided");
  }
};
const History = () => {
  const { openSnackbar } = useSnackbarContext();
  const [user_id] = useState(localStorage.getItem("user_id"));

  const {
    isPending: isHistoryLoading,
    data: history,
    error: historyError,
  } = useFetchHistory(user_id);

  const { fetchProcessedFile, isLoading: isFetchProcessedFileLoading } =
    useFetchProcessedFile();

  if (isHistoryLoading) {
    return <Loader />;
  }


  if (historyError) {
    return <p>Error fetching History: {historyError.message}</p>;
  }

  const sortedHistory = [...history].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <div className={styles.mainContainer}>
      <div className={styles.historyContainer}>
        <h2>Displaying the Latest 20 Uploads (Maximum)</h2>
        {sortedHistory.length > 0 ? (
          <table className={styles.historyTable}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Script</th>
                <th>Created At</th>
                <th>Total Rows</th>
                <th>Error Rows</th>
                <th>Status</th>
                <th>Download Processed File</th>
              </tr>
            </thead>
            <tbody>
              {sortedHistory.map((item) => (
                <tr key={item.file_id}>
                  <td>{item.name}</td>
                  <td>{item.script.name}</td>
                  <td>
                    {(() => {
                      const date = new Date(item.created_at);
                      return `${date.getUTCDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()} ${date.getUTCHours()}:${date.getUTCMinutes()}`;
                    })()}
                  </td>
                  <td>{item.result?.total_rows || "-"}</td>
                  <td>{item.result?.error_rows || "-"}</td>
                  <td>{item.status.name}</td>
                  <td>
                    {item.status.id === FILE_UPLOAD_STATUS.PROCESSED ? (
                      <PrimaryButton
                        onClick={() =>
                          handleOnClickDownloadProcessedFile(
                            item.file_id,
                            fetchProcessedFile,
                            openSnackbar
                          )
                        }
                        disabled={isFetchProcessedFileLoading}
                      >
                        Download
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton disabled>Not Available Yet</PrimaryButton>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>Nothing to show yet...</p>
        )}
      </div>
    </div>
  );
};

export default History;
